module.exports = "/_next/static/images/52e09aef246a429b802594fa504742c5-woman-playing-with-her-kids@md.jpg";